// Mutation constant
export const PURGE_AUTH = "logOut"
export const SET_AUTH = "setUser"
export const SET_ERROR = "setError"
export const SET_LOADING = "setLoading"

export const SET_STATUS = "setStatus";
export const COOKIE_USER = "ustkhts";
export const COOKIE_AUTH = "userhts";
export const COOKIE_OTP = "htsotp";

export const MODULE_TEACHER = "GV_HTS";
export const MODULE_PUPIL = "HS_HTS";
export const EMAIL_PUBLIC = 'demo@gmail.com';
export const PASS_PUBLIC = '12345678Aa@';
export const EMAIL_UNLIMITED = 'nxb1@gmail.com,vugdth@moet.gov.vn,nxb3@gmail.com,nxb_test1@nxb.edu.vn,nxb_test2@nxb.edu.vn,nxb_test3@nxb.edu.vn,nxb4@gmail.com'
export const EMAIL_NXB3 = 'nxb3@gmail.com'
export const SET_LOGOUT_ACC_FREE = 'SET_LOGOUT_ACC_FREE';
export const ID_MODAL_LOGIN = 'modal_login';
export const ID_MODAL_LOGIN_SSO = 'modal_login_sso';
export const SET_LOGIN_POPUP = 'SET_LOGIN_POPUP';
export const SET_TOGGLE_LOGIN_POPUP = 'SET_TOGGLE_LOGIN_POPUP';
export const SET_TOGGLE_LOGIN_SSO_POPUP = 'SET_TOGGLE_LOGIN_SSO_POPUP';
export const ROLE_TEACHER = 'TEACHER';
export const ROLE_HOC_SINH = 'HOC_SINH';
export const ROLE_PUPIL = 'PUPIL';
